export const apiHost = process.env.PREACT_APP_API_HOST;
const bookingApiRoot = process.env.PREACT_APP_BOOKINGS_API_HOST;
export const webSocketHost = process.env.PREACT_APP_WEB_SOCKET_HOST;

export const apiRoot = apiHost;

/**
 * @callback ProAvailabilityV4UrlBuilder
 * @param {number} proId
 * @param {string} timeZone
 * @returns {string}
*/

/**
 * @typedef {Object} apiUrls
 * @property {ProAvailabilityV4UrlBuilder} PRO_AVAILABILITY_V4
 */
export const apiUrls = {
  AUTH: `${apiRoot}v3/auth`,
  CATEGORIES: `${apiRoot}v3/categories`,
  COUNTRIES: `${apiRoot}v3/countries`,
  REGISTER: `${apiRoot}v3/users`,
  EDIT_DETAILS: `${apiRoot}users`,
  SEARCH_USERS: `${apiRoot}users/pro/find?q=`,
  GET_USER_DETAILS: `${apiRoot}users/`,
  GET_V3_USER_DETAILS: (proId) => `${apiRoot}v3/users/${proId}`,
  GET_V3_CURRENT_USER_DETAILS: `${apiRoot}v3/users`,
  GET_CLIENT_USER_DETAILS: (proId) => `${apiRoot}v3/users/${proId}`,
  GET_USER_DETAILS_REF: (proId) => `${apiRoot}users/ref/${proId}`,
  LOG_IN: `${apiRoot}auth`,
  GET_PRO_CALLS: `${apiRoot}users/activity?isPro=true`,
  GET_PERSONAL_CALLS: `${apiRoot}users/activity?isPro=false`,
  GET_TRANSACTIONS: `${apiRoot}wallet`,
  VERIFY_USER: `${apiRoot}users/signup`,
  ADD_TO_SHORTLIST: (id) => `${apiRoot}shortlist/${id}`,
  RESET_PASSWORD: `${apiRoot}security/reset`,
  UPLOAD_PHOTO: `${apiRoot}image`,
  SEND_CODE: `${apiRoot}code`,
  REGISTER_PRO: (id) => `${apiRoot}users/${id}/pro`,
  REGISTER_PRO_USER: `${apiRoot}users/pro`,
  GET_CATEGORIES: `${apiRoot}categories`,
  SEND_CONTACT_DATA: `${apiRoot}help/contact`,
  EMAIL_NOTIFICATIONS: `${apiRoot}users/emailNotifications`,
  WORKING_PRO: `${apiRoot}users/pro/work`,
  CALLS: `${apiRoot}calls`,
  CALLS_V3: `${apiRoot}v3/calls`,
  CALL_HISTORY: (id) => `${apiRoot}calls/user/${id}`,
  GET_COMPANY_TAX_ID: (id) => `${apiRoot}companies/${id}`,
  GET_CARDS: `${apiRoot}wallet/payment-method`,
  GET_BANK_ACC: `${apiRoot}wallet/bank`,
  GET_STRIPE_KEY: `${apiRoot}wallet/token`,
  TOP_UP: `${apiRoot}wallet/top-up`,
  WITHDRAW: `${apiRoot}wallet/withdraw`,
  PAYOUT_V3: `${apiRoot}v3/wallet/payout`,
  VERIFICATION_ID: `${apiRoot}wallet/documentid`,
  OAUTH2: (id, partner) => `${apiRoot}oauth2/${id}${partner}`,
  SET_STATE: (key) => `${apiRoot}users/state/${key}`,
  REMOVE_STATE: (key) => `${apiRoot}users/state/${key}`,
  AVAILABILITY: `${apiRoot}users/pro/availability`,
  FEATURED: (cid, fcid) => `${apiRoot}calls/featured?${cid ? `cid=${cid}&` : ''}fcid=${fcid}`,
  FEATURED_ALL: `${apiRoot}calls/featured/all`,
  FEATURED_AGREEMENT: `${apiRoot}users/pro/featured-agreement`,
  GET_SECTORS: `${apiRoot}categories`,
  USER_SETTINGS: `${apiRoot}users/settings`,
  SEND_NOTIFICATION_FROM_SUPPORT: (delay) => `${apiRoot}chats/${delay}`,
  DEEP_LINK: `${apiRoot}v3/branch`,
  UPLOAD_FILE: `${apiRoot}file`,
  GET_FILE: (id) => `${apiRoot}file/${id}`,
  DELETE_FILE: (id) => `${apiRoot}file/${id}`,
  BADGE: (id) => `${apiRoot}badge${id ? `/${id}` : ''}`,
  DEVICE: (id) => `${apiRoot}devices${id ? `/${id}` : ''}`,
  VERSION: (type, version) => `${apiRoot}devices/version?type=${type}&v=${version}`,
  SHARE: (query) => `${apiRoot}v3/users/pro/share?q=${query}`,
  PRO_AVAILABILITY_V4: (proId, timeZone) => `${apiRoot}v4/users/${proId}/pro/availability?timezone=${encodeURIComponent(timeZone)}`,

  REFRESH: `${apiRoot}v3/refresh-token`,

  SECURITY_RESET: `${apiRoot}v3/security/reset`,

  TOKEN: `${apiRoot}v3/token`,

  USERS_PRO_FIND: `${apiRoot}v3/users/pro/find`,

  USERS_PRO_SHARE: (query) => `${apiRoot}v3/users/pro/share?q=${query}`,

  INFO_LAUNCH: `${apiRoot}v3/info/launch`,

  USER_BOOKINGS: (userId) => `${bookingApiRoot}v3/bookings?userId=${userId}`,

  CANCEL_BOOKING: (id) => `${bookingApiRoot}v3/bookings/${id}`,

  BOOKING_DETAILS: (id) => `${bookingApiRoot}v3/bookings/${id}`,
};



// WEBPACK FOOTER //
// ./api/index.js